import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["tokens", "children", "tag"];
import React from 'react';
import { useForkRef } from "./ref.mjs";
import useEnhancedEffect from "./use/useEnhancedEffect.mjs";
export var useContextTokens = function useContextTokens() {
  return React.useContext(themeContext);
};
export var useContextTheme = function useContextTheme(ref, available) {
  var tokens = useContextTokens();
  var tokensKey = React.useMemo(function () {
    if (!tokens) return '';
    return Object.entries(tokens).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return "".concat(key, "-").concat(value);
    }).join('/');
  }, [tokens]);
  useEnhancedEffect(function () {
    if (available !== undefined && !available) return;
    if (!ref.current || !ref.current.style || !ref.current.style.setProperty) return;
    for (var token in tokens) {
      ref.current.style.setProperty(token, tokens[token]);
    }
  }, [tokensKey, available]);
};
export var contextThemeEnhance = function contextThemeEnhance(getAvailable) {
  return function (props) {
    var existingRef = props.ref;
    var available = React.useMemo(function () {
      return getAvailable === null || getAvailable === void 0 ? void 0 : getAvailable(props);
    }, Object.values(props));
    var enhanceRef = React.useRef();
    var refArr = React.useMemo(function () {
      return existingRef ? [existingRef, enhanceRef] : [enhanceRef];
    }, [existingRef, enhanceRef]);
    var ref = useForkRef(refArr);
    useContextTheme(enhanceRef, available);
    return _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    });
  };
};
var themeContext = /*#__PURE__*/React.createContext(null);
export var ThemeProvider = function ThemeProvider(props) {
  var _ref3 = props,
    _ref3$tokens = _ref3.tokens,
    providedTokens = _ref3$tokens === void 0 ? {} : _ref3$tokens,
    children = _ref3.children,
    _ref3$tag = _ref3.tag,
    Tag = _ref3$tag === void 0 ? 'div' : _ref3$tag,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var contextTokens = React.useContext(themeContext);
  var tokens = React.useMemo(function () {
    return contextTokens === null ? providedTokens : _objectSpread(_objectSpread({}, contextTokens), providedTokens);
  }, [contextTokens, providedTokens]);
  return /*#__PURE__*/React.createElement(themeContext.Provider, {
    value: tokens
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, restProps, {
    style: tokens
  }), children));
};
//# sourceMappingURL=ThemeProvider.mjs.map